import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import Swal from 'sweetalert2';
import { exit } from 'process';
@Injectable()
export class MantenedorCargasService
{
    constructor(private http: HttpClient) { }
    buscador: any = { correo: '', rut: '' }
    config: any = { itemsPerPage: 10, currentPage: 1, totalItems: 0, indexInicial: 0, indexMaximo: 10 }

    traeCargas()
    {
        return this.http.get(`${environment.urlApiCargaFamiliar}/cargasFamiliares`, { headers: this.armaCabecera() } ).toPromise()
    }

    traeCargasMuestra()
    {
        return this.http.get(`${environment.urlApiCargaFamiliar}/cargasFamiliaresMuestra`, { headers: this.armaCabecera() } ).toPromise()
    }
    
    cargasBuscador(rutCarga: any, rutTitular: any) {

        return this.http.post(`${environment.urlApiCargaFamiliar}/cargasFamiliares/buscador/`,
            {
                rut: rutCarga,
                rutTitular2: rutTitular
            },
            { headers: this.armaCabecera() }).toPromise();
    }

    traeEstadoCivil()
    {
		return this.http.get(`${environment.urlApiUsuario}/estado-civil`, { headers: this.armaCabecera() } ).toPromise()
    }


    traeTipoCarga()
    {
        return this.http.get(`${environment.urlApiCargaFamiliar}/tipo-carga`, { headers: this.armaCabecera() } ).toPromise()
    }
    
    creaCarga(carga: any)
    {
        if(carga.fechaDefuncion==null){
            carga.fechaDefuncion=""
        }

        return this.http.post(`${environment.urlApiCargaFamiliar}/cargaFamiliar`,
        {
            nombre: carga.nombre,
            apellido: carga.apellido,
            parentesco: carga.​parentesco,
            rut: carga.rut.split('-')[0],
            dv: carga.rut.split('-')[1],
            fechaNacimiento: carga.fechaNacimiento,
            fechaCreacion: carga.fechaIngreso,
            fechaExpiracion: carga.fechaExpiracion,
            fechaDefuncion: carga.fechaDefuncion,
            idSexo: carga.​sexo,
            idTipoCarga: carga.​tipoCarga,
            idUsuario: carga.​usuario,
            rutTitular: carga.rutTitular,
            idEjecutivo: carga.idEjecutivo
        },
        { headers: this.armaCabecera() } ).toPromise()
    }

    traerCarga(idCarga: any)
    {
        return this.http.get(`${environment.urlApiCargaFamiliar}/cargaFamiliar/${idCarga}`,
               { headers : this.armaCabecera() }).toPromise();
    }

    traerUsuarioSugerido(termino: string ): Observable<any[]> {
                  
					return this.http.get<any[]>(`${environment.urlApiUsuario}/sugeridos/${termino}`, { headers: this.armaCabecera() } );
    }
    traeUsuario(id: any): Observable<any[]>
    {
       	return this.http.get<any[]>(`${environment.urlApiUsuario}/afiliados/${id}`,
               { headers : this.armaCabecera() });
    }
    editarCarga(carga: any)
    {
       if(carga.fechaDefuncion=="undefined-undefined-")
       carga.fechaDefuncion=null


        return this.http.put(`${environment.urlApiCargaFamiliar}/cargaFamiliar`,
        {
            id: carga.id,
            nombre: carga.nombre,
            apellido: carga.apellido,
            rut: carga.rut.split('-')[0],
            dv: carga.rut.split('-')[1],
            fechaNacimiento: carga.fechaNacimiento,
            fechaExpiracion: carga.fechaExpiracion,
            fechaCreacion: carga.fechaCreacion,
            fechaDefuncion: carga.fechaDefuncion,
            idTipoCarga: carga.tipoCarga,
            parentesco: carga.parentesco,
            idSexo: carga.sexo,
            idUsuario:carga.usuario,
            rutTitular: carga.rutTitular,
            idEjecutivo: carga.idEjecutivo
        },
        { headers: this.armaCabecera() } ).toPromise()
    }

    modificarEstado(idUsuario: any, estadoAfiliado: any)
    {
       	 return this.http.put(`${environment.urlApiUsuario}/usuarios`,
        { id: idUsuario, estado: estadoAfiliado }, { headers : this.armaCabecera() }).toPromise();
    }

    buscar() {
        Swal.fire({
          allowOutsideClick:false,
          icon:'info',
          text:'Cargando...'
        });
        Swal.showLoading();

         if (this.buscador.rut.trim() != '') {
              let rut = this.buscador.rut.toString().trim();
              if (rut.includes(".")) { rut = rut.replaceAll(".", "") }
              let dv = "";
              let fullRut = "";
              if (rut.includes("-")) {
                  dv = rut.split('-')[1];
                  rut = rut.split('-')[0];
                  fullRut = rut + "-" + dv;
              }

                Swal.close();

          }
          else {
            Swal.close();

        }

          //this.config.totalItems = this.usuariosFinales.length
          this.config.currentPage = 1
      }

    armaCabecera()
    {
        return new HttpHeaders({
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        })
    }
}
